var parkingLocationPages = {
  'aberdeen-airport-parking': 'Aberdeen Airport Parking',
  'belfast-city-airport-parking/belfast-city-airport-parking': 'Belfast City Airport Parking',
  'belfast-international-airport-parking': 'Belfast International Airport Parking',
  'birmingham-airport-parking': 'Birmingham Airport Parking',
  'bournemouth-airport-parking': 'Bournemouth Airport Parking',
  'bristol-airport-parking': 'Bristol Airport Parking',
  'cardiff-airport-parking': 'Cardiff Airport Parking',
  'doncaster-airport-parking': 'Doncaster Airport Parking',
  'dublin-airport-parking': 'Dublin Airport Parking',
  'east-midlands-airport-parking': 'East Midlands Airport Parking',
  'edinburgh-airport-parking': 'Compare Edinburgh Airport Parking',
  'exeter-airport-parking': 'Exeter Airport Parking',
  'gatwick-parking': 'Gatwick Parking',
  'glasgow-airport-parking': 'Glasgow Airport Parking',
  'heathrow-parking': 'Heathrow Airport Parking',
  'humberside-airport-parking': 'Humberside Airport Parking',
  'inverness-airport-parking': 'Inverness Airport Parking',
  'leeds-bradford-airport-parking': 'Leeds Bradford Airport Parking',
  'liverpool-airport-parking': 'Liverpool Airport Parking',
  'london-city-airport-parking': 'London City Airport Parking ',
  'luton-airport-parking': 'Luton Airport Parking',
  'manchester-airport-parking': 'Manchester Airport Parking',
  'newcastle-airport-parking': 'Newcastle Airport Parking',
  'norwich-airport-parking': 'Norwich Airport Parking',
  'prestwick-airport-parking': 'Prestwick Airport Parking',
  'shannon-airport-parking': 'Shannon Airport Parking',
  'southampton-airport-parking': 'Southampton Airport Parking',
  'southend-airport-parking': 'Southend Airport Parking',
  'stansted-parking': 'Stansted Airport Parking',
  'teesside-airport-parking': 'Durham Tees Valley Airport Parking'
};

module.exports = parkingLocationPages;



// WEBPACK FOOTER //
// ./shared/config/parkingLocationPages.js